// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__16gf9","error":"Textarea_error__1A43p","readonly":"Textarea_readonly__1O9ai","disabled":"Textarea_disabled__1iK0f"};